// External libraries
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
// Grid code
import { Breakpoints } from '../constants';
import breakpoint from '../mixins/breakpoint';

const HideFor = styled.div`
    ${p =>
        p.xxsmall &&
        css`
            ${breakpoint('xxsmall', { only: true })} {
                display: none;
            }
        `}
    ${p =>
        p.xsmall &&
        css`
            ${breakpoint('xsmall', { only: true })} {
                display: none;
            }
        `}
    ${p =>
        p.small &&
        css`
            ${breakpoint('small', { only: true })} {
                display: none;
            }
        `}
    ${p =>
        p.medium &&
        css`
            ${breakpoint('medium', { only: true })} {
                display: none;
            }
        `}
    ${p =>
        p.large &&
        css`
            ${breakpoint('large', { only: true })} {
                display: none;
            }
        `}
    ${p =>
        p.xlarge &&
        css`
            ${breakpoint('xlarge', { only: true })} {
                display: none;
            }
        `}
    ${p =>
        p.xxlarge &&
        css`
            ${breakpoint('xxlarge', { only: true })} {
                display: none;
            }
        `}
`;

HideFor.propTypes = Object.keys(Breakpoints).reduce((props, key) => {
    return {
        ...props,
        [key]: PropTypes.bool,
    };
}, {});

export default HideFor;
